
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Target, 
  MessageSquare, 
  ExternalLink, 
  PlayCircle,
  MessageCircle,
  Settings,
  Users,
  Map,
  LogOut
} from "lucide-react";
import { Logo } from "@/components/ui/logo";
import { useIsMobile } from "@/hooks/use-mobile";

export const Sidebar = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  
  const menuItems = [
    { 
      icon: <Target size={20} />, 
      label: "Meta ADS", 
      path: "/", 
      active: location.pathname === "/",
      external: false
    },
    { 
      icon: <MessageSquare size={20} />, 
      label: "WhatsApp", 
      path: "https://chat.hoss-immo.de/", 
      active: false, 
      external: true
    },
    { 
      icon: <ExternalLink size={20} />, 
      label: "Close CRM", 
      path: "/close-crm", 
      active: location.pathname === "/close-crm",
      external: false
    },
    { 
      icon: <PlayCircle size={20} />, 
      label: "Tutorials", 
      path: "/tutorials", 
      active: location.pathname.startsWith("/tutorials"),
      external: false
    },
    { 
      icon: <MessageCircle size={20} />, 
      label: "Support", 
      path: "/support", 
      active: location.pathname === "/support",
      external: false
    },
    { 
      icon: <Settings size={20} />, 
      label: "Einstellungen", 
      path: "/settings", 
      active: location.pathname === "/settings",
      external: false
    },
    { 
      icon: <Users size={20} />, 
      label: "Partnerprogramm", 
      path: "/partner", 
      active: location.pathname === "/partner",
      external: false
    },
    { 
      icon: <Map size={20} />, 
      label: "Roadmap", 
      path: "/roadmap", 
      active: location.pathname === "/roadmap",
      external: false
    },
  ];

  return (
    <div className="w-64 h-full bg-gradient-radial from-[#1c242f] to-[#0f121a] border-r border-[#0a1a30]/30 shadow-xl z-20">
      <div className="flex flex-col h-full">
        <div className="p-4 pb-2 flex flex-col items-center border-b border-[#0a1a30]/30">
          <div className="mb-2 w-full flex justify-center">
            <Logo size="xl" isWhite={true} />
          </div>
        </div>

        <nav className="flex-1 py-4">
          <ul className="space-y-1">
            {menuItems.map((item, index) => (
              <li key={index} className="px-3">
                {item.external ? (
                  <a
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center px-4 py-3 rounded-lg transition-all duration-200 text-white/90 hover:bg-[#2e3d4d] hover:text-[#ffffffcc]`}
                  >
                    <span className="mr-3 text-white/90">{item.icon}</span>
                    <span>{item.label}</span>
                    <ExternalLink size={14} className="ml-2 opacity-70" />
                  </a>
                ) : (
                  <Link
                    to={item.path}
                    className={`flex items-center px-4 py-3 rounded-lg transition-all duration-200 ${
                      item.active 
                        ? "bg-[#263747] text-white border-l-2 border-[#41c7f0] shadow-md" 
                        : "text-white/90 hover:bg-[#2e3d4d] hover:text-[#ffffffcc]"
                    }`}
                  >
                    <span className={`mr-3 ${item.active ? "text-white" : "text-white/90"}`}>{item.icon}</span>
                    <span>{item.label}</span>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="p-4 border-t border-[#0a1a30]/30 mt-auto">
          <Link
            to="/logout"
            className="flex items-center px-4 py-3 text-white/80 hover:bg-[#2e3d4d] hover:text-[#ffffffcc] rounded-lg transition-all duration-200"
          >
            <LogOut size={20} className="mr-3" />
            <span>Abmelden</span>
          </Link>
        </div>
      </div>
    </div>
  );
};
